import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import usersIcon from '../../../images/icons/structure-object/users-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import priorityIcon from '../../../images/icons/structure-object/priority-icon.svg';
import financeIcon from '../../../images/icons/structure-object/finance-icon.svg';
import folderIcon from '../../../images/icons/dark/projects-icon.svg';
import { StructureObjectField } from '../../enums/structure-object';
import penIcon from '../../../images/icons/edit-icon.svg';
import phoneIcon from '../../../images/icons/phone-icon.svg';

export const structureClient: StructureObjectField[] = [
    {
        key: 'firstName',
        label: "Ім'я",
        order: 1,
        icon: titleIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'lastName',
        label: 'Прізвище',
        order: 2,
        icon: penIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'phone',
        label: 'Телефон',
        order: 3,
        icon: phoneIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'email',
        label: 'Електронна пошта',
        order: 4,
        icon: descIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'customerType',
        label: 'Тип',
        order: 5,
        icon: priorityIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'companyName',
        label: 'Компанія',
        order: 6,
        icon: usersIcon,
        visible: true,
    },
    {
        key: 'responsibleUserEmail',
        label: 'Відповідальний контакт',
        order: 7,
        icon: userIcon,
        isRequired: true,
        visible: true,
    }
];

export const structureClientOther: StructureObjectField[] = [
    {
        key: 'project',
        label: 'Проєкт',
        order: 1,
        icon: folderIcon,
        visible: true,
    },
    {
        key: 'income',
        label: 'Надходження',
        order: 2,
        icon: financeIcon,
        visible: true,
    },
    {
        key: 'expense',
        label: 'Витрати',
        order: 3,
        icon: financeIcon,
        visible: true,
    },
]